export default "__VITE_PUBLIC_ASSET__e9cc6add__"